export default __webpack_public_path__ + "images/arrowRightGradient.v-cae1d3eab6337e25bd40b63d728430d0.svg";